import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bot-summary-item',
  templateUrl: './bot-summary-item.component.html',
  styleUrls: ['./bot-summary-item.component.scss']
})
export class BotSummaryItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
